import type { ReactNode } from 'react';

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon: ReactNode;
  accentColor?: string;
  loading?: boolean;
}

export function StatCard({
  title,
  value,
  subtitle,
  icon,
  accentColor = 'var(--color-accent)',
  loading = false,
}: StatCardProps) {
  return (
    <div
      style={{
        background: 'var(--color-surface)',
        border: '1px solid var(--color-border)',
        borderRadius: 10,
        padding: '1.25rem 1.5rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
        minWidth: 0,
      }}
    >
      {/* Cabecera: título + icono */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <span
          style={{
            fontSize: '0.75rem',
            fontWeight: 500,
            color: 'var(--color-muted)',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
          }}
        >
          {title}
        </span>
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 32,
            height: 32,
            borderRadius: 8,
            background: `color-mix(in srgb, ${accentColor} 12%, transparent)`,
            color: accentColor,
            flexShrink: 0,
          }}
        >
          {icon}
        </span>
      </div>

      {/* Valor principal */}
      {loading ? (
        <div
          style={{
            height: 36,
            width: '60%',
            borderRadius: 6,
            background: 'var(--color-skeleton)',
            animation: 'pulse 1.5s ease-in-out infinite',
          }}
        />
      ) : (
        <span
          style={{
            fontSize: '2rem',
            fontWeight: 700,
            color: 'var(--color-text)',
            lineHeight: 1,
            letterSpacing: '-0.02em',
          }}
        >
          {value}
        </span>
      )}

      {/* Subtítulo opcional */}
      {subtitle && !loading && (
        <span
          style={{
            fontSize: '0.75rem',
            color: 'var(--color-muted)',
            lineHeight: 1.4,
          }}
        >
          {subtitle}
        </span>
      )}
    </div>
  );
}
